// Code from http://stackoverflow.com/questions/10717190/convert-svg-polygon-to-path

var polys = document.querySelectorAll('polygon,polyline');
[].forEach.call(polys, convertPolyToPath);

function convertPolyToPath (poly) {
   var svgNS = poly.ownerSVGElement.namespaceURI;
   var path = document.createElementNS(svgNS, 'path');
   var points = poly.getAttribute('points').split(/\s+|,/);
   var x0 = points.shift(),
      y0 = points.shift();
   var pathdata = 'm ' + x0 + ',' + y0 + 'L' + points.join(' ');
   if (poly.tagName == 'polygon') pathdata += 'z';
   path.setAttribute('d', pathdata);
   poly.parentNode.replaceChild(path, poly);
}

$(document).ready(function() {
	$('.DCMCmap g').click(function() {
		var gotoURL = $(this).data('url');
      var whatMap = $(this).data('map');

		if (gotoURL !== "" && gotoURL !== undefined) {
         console.log(gotoURL);
         var fullURL = gotoURL.split('.')[0]
         console.log(fullURL);
         if (fullURL === "www") {
            window.open('http://' + gotoURL, '_blank');
         } else {
            wind
            ow.open(gotoURL, '_parent');
         }
		}

      if (whatMap !== "" && whatMap !== undefined) {
         console.log(whatMap);
         console.log($(this).parent().parent().attr('id'));
         $('#worldMap').hide();
         $('#' + whatMap).show();
      }
	});
   $('.DCMCmap .back').click(function() {
      console.log("button clicked");
      var thisMap = $(this).parent().attr('id');
      $('#' + thisMap).hide();
      $('#worldMap').show();
   })
});